import fetch from '@/utils/fetch'

// 管理员列表
export const apiAdminList = ({ offset, limit }) => fetch('/a/admin/admins', { offset, limit })

// 角色列表
export const apiRoleList = () => fetch('/a/role/roles')

// 添加管理员
export const apiAddAdmin = ({ nickname, status, password, email }) =>
  fetch('/a/admin/add', {
    nickname,
    status,
    password,
    email,
  })

// 管理员详情
export const apiAdminDetail = id => fetch('/a/admin/admin', { id })

// 修改管理员
export const apiUpdateAdmin = ({ id, nickname, password, status }) => {
  const data = {
    status,
    nickname,
    id,
  }
  if (password) {
    data.password = password
  }
  return fetch('/a/admin/update', data)
}

// 修改状态
export const apiSetAdminStatus = ({ id, status }) => {
  return fetch('/a/admin/update', {
    status,
    id,
  })
}

// 删除管理员
export const apiRemoveAdmin = id => fetch('/a/admin/delete', { id })

// 设置管理员角色
export const apiSetAdminRole = ({ id, role_ids }) =>
  fetch('/a/admin/setRole', { id, role_ids }, 'POST', {
    usePayload: true,
  })

// 添加角色
export const apiAddRole = ({ role_name, decription }) =>
  fetch('/a/role/add', {
    role_name,
    decription,
  })

// 更新角色
export const apiUpdateRole = ({ id, role_name, description }) =>
  fetch('/a/role/update', {
    id,
    role_name,
    description,
  })

// 删除角色
export const apiRemoveRole = id => fetch('/a/role/delete', { id })

// 菜单列表
export const apiMenuList = () => fetch('/a/menu/menus')

// 菜单树
export const apiMenuTree = () => fetch('/a/menu/menuTree')

// 添加菜单
export const apiAddMenu = ({ parent_id, menu_name, path }) => fetch('/a/menu/add', { parent_id, menu_name, path })

// 更新菜单
export const apiUpdateMenu = ({ id, parent_id, menu_name, path }) =>
  fetch('/a/menu/update', { id, parent_id, menu_name, path })

// 删除菜单
export const apiRemoveMenu = id => fetch('/a/menu/delete', { id })

// 添加Api
export const apiAddApi = ({ menu_id, api }) => fetch('/a/menu/addApi', { menu_id, api })

// 删除api
export const apiRemoveApi = id => fetch('/a/menu/deleteApi', { id })

// 角色详情
export const apiRoleDeatail = id => fetch('/a/role/role', { id })

// 设置菜单权限
export const apiSetRoleAccess = ({ id, menu_ids }) =>
  fetch('/a/role/setMenu', { id, menu_ids }, 'POST', {
    usePayload: true,
  })
